<template>
  <div ref="cell" :class="classes">
    <template v-if="renderType === 'index'">{{ index + 1 }}</template>
    <template v-if="renderType === 'nativeIndex'">{{ naturalIndex }}</template>
    <template v-if="renderType === 'selection'">
      <t-checkbox :value="checked"
                  :disabled="disabled"
                  label=""
                  @on-change="$_toggleSelect"></t-checkbox>
    </template>
    <template v-if="renderType === 'normal'">
      <template v-if="treeData && treeData.key === column.key">
        <span :class="treeExpandClasses" :style="treeExpandStyle"></span>
        <t-icon v-if="row._hasChild" :type="treeExpandIcon" :class="prefixTableClass+'__tree-icon'" @click.native="$_onTreeExpandIconClick"></t-icon>
      </template>
      <template v-if="column.editable === true">
        <div v-show="!editCheck" :class="`${prefixTableClass}-edit__text`">
          <span :class="cellTextClasses" v-html="row[column.key]"></span>
        </div>
        <t-input v-show="editCheck"
                 ref="cellInput"
                 v-model="row[column.key]"
                 :class="[prefixTableClass + '-edit__input']"
                 @on-blur="$_onEditInputBlur"
                 @on-enter="$_onEditInputEnter"></t-input>
        <span :class="[prefixTableClass + '-edit__action']">
          <a v-show="!editCheck" @click="$_onEditIconClick"><t-icon type="pencil"></t-icon></a>
        </span>
      </template>
      <template v-if="!column.editable">
        <t-tooltip v-if="typeof(row[column.key])!==undefined && row[column.key]!=='' && row[column.key]!==null && (column.ellipsis || allEllipsis)" :content="row[column.key]" :disabled="!column._isEllipsis">
          <div :class="cellTextClasses">
            <span :class="[prefixTableClass + '__cell--text--inner']" v-text="row[column.key]"></span>
          </div>
        </t-tooltip>
        <span v-if="!(column.ellipsis || allEllipsis)" :class="cellTextClasses" v-html="row[column.key]"></span>
      </template>
    </template>
    <template v-if="renderType === 'expand' && !row._disableExpand">
      <div :class="expandClasses">
        <t-icon :type="expandIcon" class="expand-icon" @click.native="$_onExpandIconClick"></t-icon>
      </div>
    </template>
    <template v-if="renderType === 'render'">
      <div class="d-flex align-items-center">
        <template v-if="treeData && treeData.key === column.key">
          <span :class="treeExpandClasses" :style="treeExpandStyle"></span>
          <t-icon v-if="row._hasChild"
                  :type="treeExpandIcon"
                  :class="prefixTableClass+'__tree-icon'"
                  style="cursor:pointer"
                  @click.native="$_onTreeExpandIconClick"></t-icon>
        </template>
        <div>
          <t-expand :row="row"
                    :column="column"
                    :index="index"
                    :render="column.render"></t-expand>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import TExpand from './expand'
import TIcon from '../icon/icon.vue'
import TCheckbox from '../checkbox/checkbox.vue'

export default {
  name: 'TTableCell',
  components: { TIcon, TCheckbox, TExpand },
  props: {
    prefixTableClass: String,
    treeData: Object,
    row: Object,
    column: Object,
    naturalIndex: Number,
    index: Number,
    checked: Boolean,
    disabled: Boolean,
    expanded: Boolean,
    allEllipsis: Boolean
  },
  data() {
    return {
      editCheck: false,
      renderType: '',
      uid: -1,
      context: this.$parent.$parent.$parent.currentContext
    }
  },
  computed: {
    classes() {
      return [
        `${this.prefixTableClass}__cell`,
        {
          [`${this.prefixTableClass}__cell--with-expand`]:
            this.renderType === 'expand',
          [`${this.prefixTableClass}__cell--edit`]:
            this.renderType === 'normal' && this.column.editable === true,
          [`${this.prefixTableClass}__cell--tree`]:
            this.renderType === 'normal' &&
            this.treeData &&
            this.treeData.key === this.column.key
        }
      ]
    },
    cellTextClasses() {
      return [
        `${this.prefixTableClass}-cell__text-content`,
        {
          [`${this.prefixTableClass}__cell--ellipsis`]:
            this.column.ellipsis || this.allEllipsis || false
        }
      ]
    },
    expandClasses() {
      return [
        `${this.prefixTableClass}__cell--expand`,
        {
          [`${this.prefixTableClass}__cell--expand-expanded`]: this.expanded
        }
      ]
    },
    expandIcon() {
      return this.expanded ? `minus-circle-outline` : `plus-circle-outline`
    },
    treeExpandClasses() {
      return [
        `${this.prefixTableClass}__row-indent`,
        `indent__level-${this.row._indent}`
      ]
    },
    treeExpandStyle() {
      let treeIndentSize = 0
      if (this.treeData && this.treeData.treeIndentSize) {
        treeIndentSize = this.treeData.treeIndentSize
      }
      let paddingLeft = treeIndentSize * this.row._indent
      if (!this.row.children || this.row.children.length === 0) {
        paddingLeft += treeIndentSize // 叶子节点需要多加一个缩进距离，因为它没有展开图标
      }
      return `padding-left: ${paddingLeft}px;`
    },
    treeExpandIcon() {
      return this.row._isOpenNode ? `menu-down` : `menu-right`
    }
  },
  created() {
    if (this.column.type === 'index') {
      this.renderType = 'index'
    } else if (this.column.type === 'nativeIndex') {
      this.renderType = 'nativeIndex'
    } else if (this.column.type === 'selection') {
      this.renderType = 'selection'
    } else if (this.column.type === 'expand') {
      this.renderType = 'expand'
    } else if (this.column.render) {
      this.renderType = 'render'
    } else {
      this.renderType = 'normal'
    }
  },
  methods: {
    $_toggleSelect() {
      this.$parent.$parent.$parent.toggleSelect(this.index, !this.row._checked)
    },
    $_onExpandIconClick() {
      this.$parent.$parent.$parent.toggleExpand(this.index)
    },
    $_onEditInputEnter() {
      this.$_checkCell()
    },
    $_onEditInputBlur() {
      this.$_checkCell()
    },
    $_checkCell() {
      this.$parent.$parent.$parent.updateData(
        this.index,
        this.column.key,
        this.row
      )
      this.editCheck = false
    },
    $_onEditIconClick() {
      this.editCheck = true
      this.$nextTick(function() {
        this.$refs.cellInput.focus()
      })
    },
    $_onTreeExpandIconClick() {
      this.row._isOpenNode = !this.row._isOpenNode
      this.$parent.$parent.toggleTreeNode(this.index, this.row)
    }
  }
}
</script>



// WEBPACK FOOTER //
// cell.vue?49787730